import BaseAPI from './base'

class PartnerAPIKeyAPI extends BaseAPI {
  constructor() {
    super()
    this.client.defaults.baseURL = `${this.baseURL}/company`
  }

  getPartnerAPIKeys = (query) => this.client.get(`api-keys?${query}`)

  getPartnerAPIKey = (id) => this.client.get(`api-keys/${id}`)

  addPartnerAPIKey = (data) => this.client.post(`api-keys`, data)

  updatePartnerAPIKey = ({ partnerAPIkeyId, payload }) =>
    this.client.patch(`api-keys/${partnerAPIkeyId}`, payload)

  deletePartnerAPIKey = (id) => this.client.delete(`api-keys/${id}`)

  regeneratePartnerAPIKey = (id) =>
    this.client.post(`api-keys/${id}/regenerate`)

  getLogsPartnerAPIKey = (query) => this.client.get(`api-keys/logs?${query}`)

  addPeriodPartnerAPIKey = ({ partnerAPIKeyId, payload }) =>
    this.client.post(`api-key/${partnerAPIKeyId}/periods`, payload)

  updatePeriodPartnerAPIKey = ({ periodId, partnerAPIKeyId, payload }) =>
    this.client.patch(`api-key/${partnerAPIKeyId}/periods/${periodId}`, payload)

  deletePeriodPartnerAPIKey = ({ periodId, partnerAPIKeyId }) =>
    this.client.delete(`api-key/${partnerAPIKeyId}/periods/${periodId}`)
}

export default new PartnerAPIKeyAPI()
